const moment = require('moment');
const d3 = require('d3');
const i18n = require('core/i18n').i18n;
const { getFormattedAmount, getCurrencySymbol } = require('utilities/currencyHelper');
const Constants = require('constants/index');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const es_ES = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['$', '€'],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    'shortDays': ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    'shortMonths': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
};
const en_US = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['\$', '€'],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};

const decideAxisDateLabel = (maxDate, minDate) => {
    const diffDays = maxDate.diff(minDate, 'days');
    let loc;
    const locale = i18n.formatText(DATE_PICKER_CUSTOM_LOCALE);

    if (locale === 'es') {
        loc = d3.locale(es_ES);
    } else if (locale === 'en') {
        loc = d3.locale(en_US);
    } else {
        loc = d3.locale(en_US);
    }

    if (diffDays < 32) {
        return loc.timeFormat('%d %b');
    } else if (diffDays > 31 && diffDays < 360) {
        return loc.timeFormat('%b %Y');
    } else {
        return loc.timeFormat('%Y');
    }
};
// dataArray
const yAxisFormatLabel = (d, currencyId) => {
    const moneyObj = { amount: d, currency: currencyId };
    const curr = getCurrencySymbol(moneyObj);
    const amount = getFormattedAmount(moneyObj);

    return amount + ' ' + curr;
};

const createTooltip = (d, currencyId) => {
    const locMoment = moment.utc(d.get('Date')).locale(DATE_PICKER_CUSTOM_LOCALE);
    const formattedDate = locMoment.format('DD MMM YYYY');
    const moneyObj = { amount: d.get('Value'), currency: currencyId };
    const fa = getFormattedAmount(moneyObj);
    const fs = getCurrencySymbol(moneyObj);

    return `${formattedDate} <span>${fa} ${fs}</span>`;
};

const createTopText = lastData => {
    const moneyObj = {
        amount: lastData.get('Value'),
        currency: '$'
    };
    const fa = getFormattedAmount(moneyObj);
    const fs = getCurrencySymbol(moneyObj);
    const todayText = i18n.formatText('myWallet-today');

    return `<span>${todayText}</span>\
        <span>${fa} ${fs}</span>`;
};

const xTicksAmount = chartType => {
    /*
     * This could be needed to adjust axis ticks;
     */
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_HISTORY) {
        return 6;
    }
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_YTD) {
        return 4;
    }
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_ONEMONTH) {
        return 4;
    }
};

const yTicksAmount = chartType => {
    /*
     * This could be needed to adjust axis ticks;
     */
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_HISTORY) {
        return 4;
    }
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_YTD) {
        return 4;
    }
    if (chartType === Constants.MYWALLET_EVOLUTION_CHART_TYPE_ONEMONTH) {
        return 4;
    }
};

module.exports = {
    decideAxisDateLabel,
    yAxisFormatLabel,
    createTooltip,
    createTopText,
    xTicksAmount,
    yTicksAmount
};
